<template>
  <div>
    <div
      ref="modal"
      class="modal fade"
      :class="{ show: active, 'd-block': active }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("detail_txt") }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              v-on:click="$emit('closeModal')"
              aria-label="btn-close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="this.data.method == 'create'">
              <div class="row mb-3" style="padding-left: 25px">
                <div class="col-3">
                  <label for="load_id" class="form-label">Load Id</label>
                  <textarea
                    name="load_id"
                    class="form-control"
                    id="load_id"
                    :value="forms.load_id"
                    @paste="pasteLoad"
                    @input="inputLoad"
                  ></textarea>
                </div>
                <div class="col-3">
                  <label for="loading_date" class="form-label">{{
                    $t("loadingDate")
                  }}</label>
                  <date-range-picker
                    style="width: 100%"
                    control-container-class="form-control"
                    :locale-data="locale"
                    v-model="dateFilter"
                    :opens="opens"
                    :singleDatePicker="false"
                    :timePicker24Hour="true"
                    :timePicker="true"
                    :showWeekNumbers="false"
                    :ranges="customDatePickerRange()"
                  >
                  </date-range-picker>
                </div>
                <div class="col-3">
                  <label for="loading_date" class="form-label">Customer</label>
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    :value="company.name"
                  />
                  <!-- <multiselect
                    @search-change="asyncSearchCompany"
                    v-model="company"
                    :options="fetchCompany"
                    label="name"
                    :searchable="true"
                    track-by="name"
                    @open="removeReadonly"
                    ref="inputCompany"
                    placeholder="Please Select Company"
                  >
                    <span slot="noResult">-</span>
                  </multiselect> -->
                </div>
                <div class="col">
                  <br />
                  <button class="btn btn-warning mx-1" @click="searchLoad">
                    {{ $t("search_txt") }}
                  </button>
                  <button
                    class="btn btn-secondary btn-sm mx-1"
                    @click="clearFilter"
                  >
                    {{ $t("resetFilter") }}
                  </button>
                </div>
              </div>
            </div>
            <!-- :rows="rows"  -->
            <vue-good-table
              title="list-order-ct"
              mode="remote"
              :select-options="{
                enabled: true,
                selectOnCheckboxOnly: true,
                selectionText: $t('data_selected'),
                clearSelectionText: $t('clear'),
              }"
              @on-selected-rows-change="selectionChanged"
              :totalRows="totalRecords"
              :line-numbers="true"
              :isLoading.sync="isLoading"
              :pagination-options="{
                enabled: false,
              }"
              :sort-options="{
                enabled: false,
              }"
              :columns="columns"
              :rows="rows"
            >
              <div slot="selected-row-actions">
                <button
                  class="btn btn-success"
                  type="submit"
                  :disabled="isLoading"
                  @click="submitData"
                  v-if="this.data.method == 'create'"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm ms-auto"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ $t("addDetail") }}
                </button>
                <!-- <button
                            class="btn btn-success btn-xs"
                            @click="addData"
                          >
                            Add
                          </button> -->
              </div>
            </vue-good-table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="$emit('closeModal')"
            >
              {{ $t("close_txt") }}
            </button>
            <!-- <button
              class="btn btn-success"
              type="submit"
              :disabled="isLoading"
              @click="submitData"
              v-if="this.data.method == 'create'"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm ms-auto"
                role="status"
                aria-hidden="true"
              ></span>
              {{ $t("addDetail") }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
// import multiselect from "vue-multiselect";
import moment from "moment";
export default {
  name: "modalProformaInvoiceDetail",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
  },
  components: {
    DateRangePicker,
    // multiselect: multiselect,
  },
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
        this.rows = [];
        this.totalRecords = 0;
        this.clearFilter();
        this.setColumn();
        if (this.data.method == "detail") {
          this.loadItems();
        }

        this.company = {
          company_id: this.data?.data?.company_id
            ? this.data?.data?.company_id
            : null,
          name: this.data?.data?.company_name
            ? this.data.data.company_name
            : null,
        };

        this.proforma_invoice_header_id = this.data?.data
          ?.proforma_invoice_header_id
          ? this.data.data.proforma_invoice_header_id
          : null;
      },
      immediate: true,
      deep: true,
    },
    'forms.load_id':function(newVal){
      console.log('load_id changed' + newVal);
    }
  },
  
  data() {
    // const startDate = new Date();
    // const endDate = new Date();
    return {
      isLoading: false,
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      active: this.showModal,
      fetchCompany: [],
      totalRecords: 0,
      dateFilter: {
        startDate: null,
        endDate: null,
      },
      forms: {
        load_id:0,
      },
      columns: [],
      rows: [],
      company: {},
      proforma_invoice_header_id: null,
      rowsSelection: null,
      additionalHeader: [],
    };
  },
  methods: {
    inputLoad(ev) {
      this.forms.load_id = ev.target.value;
    },
    pasteLoad(ev) {
      ev.preventDefault();
      let text = ev.clipboardData.getData("text");
      text = text.replace(/(?:\r\n|\r|\n)/g, ",");
      text = text.replace(" ",",");
      this.forms.load_id = text;
    },
    customDatePickerRange() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);

      let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return {
        Today: [today, today],
        Yesterday: [yesterday, yesterday],
        "This month": [thisMonthStart, thisMonthEnd],
        // 'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        "Last month": [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      };
    },
    setColumn() {
      this.columns = [
        {
          label: "Sold to Party Name",
          field: "sold_to_party",
        },
        {
          label: "Load Id",
          field: "load_id",
        },
        {
          label: "Nopol",
          field: "vehicle_no",
        },
        {
          label: "Equipment Description",
          field: "equipment_description",
        },
        {
          label: "Loading Date",
          field: "loading_date",
        },
        {
          label: "Unloading date",
          field: "unloading_date",
        },
        {
          label: "Origin",
          field: "origin",
        },
        {
          label: "Destination",
          field: "destination",
        },
        {
          label: "Delivery Order",
          field: "delivery_order",
        },
        {
          label: "Shipment Numbers",
          field: "shipment_numbers",
        },
        {
          label: "UOM",
          field: "uom",
        },
        {
          label: "Qty / Ton",
          field: "qty",
        },
        {
          label: "Ship To",
          field: "ship_to",
        },
        {
          label: "Driver Id",
          field: "driver_id",
        },
        {
          label: "Driver Name",
          field: "driver_name",
        },
        {
          label: "Billable Rate",
          field: "billable_rate",
          formatFn: this.formatCurrency,
        },
      ];
    },
    clearFilter() {
      this.dateFilter.startDate = null;
      this.dateFilter.endDate = null;
      this.forms = {
        load_id:null,
      };
    },
    selectionChanged(ev) {
      this.rowsSelection = [];

      this.rowsSelection = ev.selectedRows;
    },
    searchLoad() {
      let payload = {
        load_id: this.forms?.load_id ? this.forms.load_id : "",
        company_id: this.company?.company_id ? this.company.company_id : "",
        customer: this.company?.name ? this.company.name : "",
      };
      if (
        this.dateFilter.startDate != undefined ||
        this.dateFilter.endDate != undefined
      ) {
        payload["loading_date"] =
          moment(this.dateFilter.startDate).format("YYYY-MM-DD") +
          "~" +
          moment(this.dateFilter.endDate).format("YYYY-MM-DD");
      } else {
        payload["loading_date"] = "";
      }
      // this.setColumn();

      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice +
        `v1/proforma-invoice/get-load?company_id=${payload.company_id}&load_id=${payload.load_id}&loading_date=${payload.loading_date}&proforma_invoice_header_id=${this.proforma_invoice_header_id}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.rows = response.data.datas.detail;
          this.totalRecords = response.data.datas.detail.length;

          let additionalHeader = response.data.datas.additionalHeader;
          this.additionalHeader = additionalHeader;
          additionalHeader.forEach((val) => {
            let field = val;
            let text_label = val
              .replaceAll("_", " ")
              .split(" ")
              .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
              .join(" ");
            this.columns.push({
              label: text_label,
              field: field,
              formatFn: this.formatCurrency,
            });
          });

          this.columns.push({
            label: "Total",
            field: "total",
            formatFn: this.formatCurrency,
          });

          // let list = "";
          // if (response.data.datas.error.length > 0) {
          //   let errors = response.data.datas.error;
          //   errors.forEach((item) => {
          //     list +=
          //       "Step : " + item.step + " | Message :" + item.message + "<br>";
          //   });

          //   this.$swal({
          //     icon: "error",
          //     title: "Error !!!",
          //     html: list,
          //   });
          // }
          let table = '<table s class="table"><thead><tr><td>No</td><td>Load Id</td><td>Step</td><td>Message</td></tr></thead>';
          if (response.data.datas.error.length > 0) {
            let errors = response.data.datas.error;
            errors.forEach((item,key) => {
              table +=
                `
                <tr>
                  <td>
                    ${key+1}
                  </td>
                  <td>
                    ${item.load_id}
                  </td>
                  <td>
                    ${item.step}
                  </td>
                  <td style='text-align:left'>
                    ${item.message}
                  </td>
                </tr>
                `;
            });

            table += "</table>";
            this.$swal({
              icon: "error",
              title: "Error !!!",
              html: table,
              width:'800px'
            });
          }

          this.isLoading();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                //this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    submitData() {
      let data = null;
      if (this.rowsSelection == null || this.rowsSelection.length == 0) {
        data = this.rows;
      } else {
        data = this.rowsSelection;
      }
      this.$emit("sendData", data, this.additionalHeader);
    },
    loadItems() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice +
        "v1/proforma-invoice/detail/" +
        this.data.data.proforma_invoice_header_id;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.rows = response.data.datas.details;
          this.totalRecords = response.data.datas.details.length;
          this.isLoading = false;

          let additionalHeader = response.data.datas.additionalHeader;
          this.additionalHeader = additionalHeader;
          additionalHeader.forEach((val) => {
            let field = val;
            let text_label = val
              .replaceAll("_", " ")
              .split(" ")
              .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
              .join(" ");
            this.columns.push({
              label: text_label,
              field: field,
              formatFn: this.formatCurrency,
            });
          });

          this.columns.push({
            label: "Total",
            field: "total",
            formatFn: this.formatCurrency,
          });
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                //this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    formatCurrency(val) {
      return parseInt(val).toLocaleString();
    },
    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?limit=10&name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    removeReadonly() {
      this.$nextTick(() => {
        const input = this.$refs.inputCompany.$el.querySelector(
          ".multiselect__input"
        );
        if (input && input.hasAttribute("readonly")) {
          input.removeAttribute("readonly");
        }
      });
    },
  },
  mounted() {
    // this.loadCompany();
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>
